<template>
  <div>
    <ModalComponent v-if="challengeRequired">
      <div slot="header" class="security-header">
        <div class="dialog-c-title">
          {{ strings.verifyMailPlaceholder }}
          <div class="top-right" slot="top-right">
            <button @click="close()">X</button>
          </div>
        </div>
      </div>
      <div slot="body" class="security-body">
        <div class="modal__text">
          {{ strings.verifyMailText }}
          <span class="sender-id">{{ senderId }}</span>
          <div
            class="resendButton"
            v-bind:class="{ 'resendButton-disabled': resend == true }"
            @click="resendCode()"
          >
            {{ strings.resendMailBtn }}
          </div>
        </div>
        <div v-if="challengeError !== ''" class="modal__text error_text">
          {{ strings.wrongVerificationCode }}
        </div>
        <input
          ref="verificationCode"
          class="input-verification-code"
          v-model="verification_code"
        />
      </div>
      <div slot="footer" class="security-footer">
        <button
          class="modal-default-button modal-default-button-ok"
          @click="submit()"
        >
          {{ strings.verifyMailBtn }}
        </button>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
import ModalComponent from "../components/ModalComponent";

export default {
  data() {
    return {
      verification_code: "",
      resend: false
    };
  },
  props: ["senderId"],
  components: {
    ModalComponent
  },
  created() {
    //this.$el.querySelector('.input-verification-code').focus();
  },
  computed: {
    strings() {
      return this.$store.state.strings;
    },
    challengeRequired() {
      return this.$store.state.challengeRequired;
    },
    challengeError() {
      return this.$store.state.challengeError;
    }
  },
  methods: {
    close: function() {
      this.$store.commit("setChallengeRequired", false);
    },
    submit: function() {
      // this.$store.commit("setChallengeRequired", false);
      this.$store.commit("setChallengeError", "");
      this.$emit("verificationCodeSubmitted", this.verification_code);
    },
    resendCode: function() {
      if (this.resend == false && this.verification_code.length > 0) {
        this.resend = true;
        this.$store.dispatch("resendVerification", this.senderId).then(() => {
          this.resend = false;
        });
      }
    }
  }
};
</script>

<style scoped>
.dialog-c-title {
  border-bottom: none;
  font-size: 24px;
  color: #002f3d;
  font-weight: 400 !important;
  margin-bottom: 0px;
  padding-bottom: 0px !important;
}
.security-header {
  border-bottom: none;
  font-size: 24px;
  color: #002f3d;
  font-weight: 400 !important;
  margin-bottom: 20px;
  text-align: left;
  margin-left: 0px;
}
.security-footer {
  border-top: none;
  padding-bottom: 0px !important;
}
.security-footer {
  margin-bottom: -20px;
}
.modal__text {
  font-weight: normal;
}
.security-header {
  margin-bottom: -15px;
  padding-bottom: 0px;
}
.sender-id {
  font-style: italic;
}
.input-verification-code {
  margin-top: 25px;
  text-transform: uppercase;
}
.resendButton {
  font-weight: 600;
  text-decoration: underline;
  display: inline;
  margin-left: 10px;
  cursor: pointer;
}
.resendButton-disabled {
  cursor: not-allowed;
  background-color: #ebebe4 !important;
  color: #c6c6c6;
}
.error_text {
  margin-top: 10px;
  color: red;
  margin-bottom: 0px;
}
</style>

<style>
.security-footer .modal-default-button {
  border-color: #2aaa58;
  background-color: #2aaa58;
  margin-bottom: 0px;
}
</style>